import React, { ChangeEvent, ForwardedRef, forwardRef, PropsWithChildren } from 'react';
import { CField, CFieldAutoCapitalize, CFieldAutoCorrect, CFieldEnterKeyHint, CFieldInputMode, CFieldProps } from '@/src/components/c-field/CField';
import { CIcon, CIcons } from '@/src/components/c-icon/CIcon';

export interface CFieldSearchProps extends CFieldProps {
  autoCapitalize?: CFieldAutoCapitalize;
  autoCorrect?: CFieldAutoCorrect;
}

export const CFieldSearch = forwardRef(function CPasswordField(props: PropsWithChildren<CFieldSearchProps>, ref: ForwardedRef<HTMLInputElement>): React.JSX.Element {
  return (
    <CField
      id={props.id}
      value={props.value}
      label={props.label}
      class={props.class}
      disabled={props.disabled}
      validations={props.validations}
      placeholder={props.placeholder}
      testSelector={props.testSelector}
      required={props.required}
      hideMessageContainer={props.hideMessageContainer}
      fullWidth={props.fullWidth}
      onBlur={props.onBlur}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onKeyUp={props.onKeyUp}
      onKeyDown={props.onKeyDown}
      formId={props.formId}
      security={props.security}
      icon={true}
    >
      {({ id, value, setValue }) => (
        <>
          <CIcon
            class="c-field__icon"
            icon={CIcons.Search}
          />
          <input
            ref={ref}
            name={props.name}
            pattern={props.pattern}
            required={props.required}
            disabled={props.disabled}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            onKeyUp={props.onKeyUp}
            onKeyDown={props.onKeyDown}
            aria-disabled={props.disabled}
            className="c-field__input"
            inputMode={CFieldInputMode.Search}
            enterKeyHint={CFieldEnterKeyHint.Search}
            autoCapitalize={props.autoCapitalize}
            autoCorrect={props.autoCorrect}
            id={id}
            type={'text'}
            value={value}
            autoComplete={props.autoComplete}
            placeholder={props.placeholder}
            onChange={(event: ChangeEvent) => setValue(event, (event.currentTarget as HTMLInputElement).value)}
          />
        </>
      )}
    </CField>
  );
});